"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCache = void 0;
const ramda_1 = require("ramda");
// Used to prevent Maximum call stack size exceeded when there is circular reference in declaration
function createCache() {
    const cacheMap = new Map();
    return {
        set(declaration, caster) {
            cacheMap.set(declaration, caster);
            return caster;
        },
        get(declaration) {
            for (const key of cacheMap.keys()) {
                if (ramda_1.equals(key, declaration)) {
                    return cacheMap.get(key);
                }
            }
        }
    };
}
exports.createCache = createCache;
